import { render, staticRenderFns } from "./DivTable.vue?vue&type=template&id=5e49979a&"
import script from "./DivTable.vue?vue&type=script&lang=js&"
export * from "./DivTable.vue?vue&type=script&lang=js&"
import style0 from "./DivTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports